(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["youtube-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youtube-video-carousel')) {
    customElements.define(
      'youtube-video-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-viewport]');
          this.cards = [...this.querySelectorAll('[data-card]')];
          this.previousButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');
          this.dots = this.querySelector('[data-dots]');
          this.controls = this.querySelector('[data-controls]');

          if (!this.viewport || !this.cards.length || !this.previousButton || !this.nextButton || !this.dots || !this.controls) return;

          this.index = 0;
          this.previousButton.addEventListener('click', () => this.goToItem(this.index - 1));
          this.nextButton.addEventListener('click', () => this.goToItem(this.index + 1));

          this.resizeObserver = new ResizeObserver(() => this.keepItemVisible(false));
          this.resizeObserver.observe(this);
          this.refresh();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        refresh() {
          this.index = Math.max(0, Math.min(
this.index, this.cards.length - 1));
          this.dots.replaceChildren();

          this.cards.forEach((card, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tap-area';
            button.setAttribute('aria-label', String(index + 1));
            button.addEventListener('click', () => this.goToItem(index));
            this.dots.append(button);
          });

          this.controls.hidden = this.cards.length <= 1;
          this.updateControls();
        }

        goToItem(index) {
          const itemCount = this.cards.length;
          this.index = (index + itemCount) % itemCount;
          this.updateControls();
          this.keepItemVisible(true);
        }

        keepItemVisible(smooth) {
          const card = this.cards[this.index];
          if (!card) return;

          const viewportLeft = this.viewport.scrollLeft;
          const viewportRight = viewportLeft + this.viewport.clientWidth;
          const cardLeft = card.offsetLeft;
          const cardRight = cardLeft + card.offsetWidth;
          const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          let targetLeft = viewportLeft;

          if (cardLeft < viewportLeft) {
            targetLeft = cardLeft;
          } else if (cardRight > viewportRight) {
            targetLeft = cardRight - this.viewport.clientWidth;
          }

          this.viewport.scrollTo({
            left: Math.max(0, Math.min(targetLeft, maxScroll)),
            behavior: smooth ? 'smooth' : 'auto'
          });
        }

        updateControls() {
          [...this.dots.children].forEach((button, index) => {
            button.setAttribute('aria-current', index === this.index ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
